import axios from "axios";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";
import "firebase/firestore";

export const getNotification =
  (athleteId, instituteName) => async (dispatch) => {
    try {
      let schoolId = null;

      if (instituteName) {
        const schoolSnap = await firebase
          .firestore()
          .collection("users")
          .where("instituteName", "==", instituteName)
          .limit(1)
          .get();

        if (!schoolSnap.empty) {
          schoolId = schoolSnap.docs[0].id;
        }
      }

      const notificationRef = firebase.firestore().collection("notification");

      const unsubAthlete = notificationRef
        .where("athleteId", "==", athleteId)
        .orderBy("createdAt", "desc")
        .onSnapshot(async (athleteQuery) => {
          const athleteNotifs = await Promise.all(
            athleteQuery.docs
              .filter((doc) => !doc.data().isRead?.includes(athleteId))
              .map(async (doc) => {
                const fan = await firebase
                  .firestore()
                  .collection("users")
                  .doc(doc.data().fanId)
                  .get();

                return {
                  ...doc.data(),
                  id: doc.id,
                  fanName: fan.data()?.name || "",
                  fanEmail: fan.data()?.email || "",
                };
              })
          );

          if (schoolId) {
            notificationRef
              .where("schoolId", "==", schoolId)
              .orderBy("createdAt", "desc")
              .onSnapshot(async (schoolQuery) => {
                const schoolNotifs = await Promise.all(
                  schoolQuery.docs
                    .filter((doc) => !doc.data().isRead?.includes(athleteId))
                    .map(async (doc) => {
                      const fan = await firebase
                        .firestore()
                        .collection("users")
                        .doc(doc.data().fanId)
                        .get();

                      return {
                        ...doc.data(),
                        id: doc.id,
                        fanName: fan.data()?.name || "",
                        fanEmail: fan.data()?.email || "",
                      };
                    })
                );

                const allNotifs = [...athleteNotifs, ...schoolNotifs].sort(
                  (a, b) => b?.createdAt?.seconds - a?.createdAt?.seconds
                );

                dispatch({
                  type: "GET_UNREAD_NOTIFICATIONS",
                  payload: allNotifs,
                });
              });
          } else {
            dispatch({
              type: "GET_UNREAD_NOTIFICATIONS",
              payload: athleteNotifs,
            });
          }
        });
    } catch (err) {
      console.error("Error getting notifications: ", err);
    }
  };

export const sendEmailToFanNotification =
  (payload, onSuccess = () => {}) =>
  (dispatch) => {
    const athleteResponseEmail = `
                Hi Sport Fan, I see you bought a badge from me.Thanks so much! I just wanted to make sure you know I am available to chat.You can locate the steps to arrange a chat with me by visiting your Chat home Page.I hope to hear from you soon! Cheers.
              `;

    const options = {
      to: payload?.fanEmail,
      subject: "Response from Athlete",
      text: athleteResponseEmail,
    };

    axios
      .post(
        "https://us-central1-fans-help-players.cloudfunctions.net/app/sendUserEmail",
        options
      )
      .then(async (response) => {
        await firebase
          .firestore()
          .collection("notification")
          .doc(payload.id)
          .delete();
        toast.success("Email Send Successfully");
        onSuccess();
      })
      .catch((error) => {
        toast.error("Error occured try Again !");
      });
  };

export const getReadNotification =
  (athleteId, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const notificationRef = firebase.firestore().collection("notification");
      notificationRef
        .orderBy("createdAt", "desc")
        .onSnapshot(async (querySnap) => {
          const readNotifications = await Promise.all(
            querySnap.docs
              .filter((doc) => {
                const data = doc.data();
                return data.isRead?.includes(athleteId);
              })
              .map(async (doc) => {
                const fan = await firebase
                  .firestore()
                  .collection("users")
                  .doc(doc.data().fanId)
                  .get();

                return {
                  ...doc.data(),
                  id: doc.id,
                  fanName: fan.data()?.name || "",
                  fanEmail: fan.data()?.email || "",
                };
              })
          );

          dispatch({
            type: "GET_READ_NOTIFICATIONS",
            payload: readNotifications,
          });

          onComplete();
        });
    } catch (err) {
      console.error("🔥 Error getting read notifications: ", err);
    }
  };

export const markNotificationAsRead = (
  docId,
  athleteId,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      const data = {
        isRead: firebase.firestore.FieldValue.arrayUnion(athleteId),
      };

      await firebase
        .firestore()
        .collection("notification")
        .doc(docId)
        .update(data);
      onSuccess();
    } catch (error) {
      console.error("🔥 Error updating isRead:", error);
    }
  };
};

export const updateUserDeviceToken = (token, userId) => {
  return async (dispatch) => {
    try {
      await firebase.firestore().collection("users").doc(userId).update({
        fcmToken: token,
      });

      const updatedDoc = await firebase
        .firestore()
        .collection("users")
        .doc(userId)
        .get();

      const updatedUser = { id: updatedDoc.id, ...updatedDoc.data() };

      dispatch({
        type: "UPDATE_USER_DEVICE_TOKEN",
        payload: updatedUser,
      });

    } catch (error) {
      console.error("🔥 Error updating device token:", error);
    }
  };
};
